import type { IRequestInit } from '@servicestack/client';
import { JsonServiceClient } from '@servicestack/client';
import cache from 'connect/web/src/cache';
import settings from './settings';

const client = new JsonServiceClient(settings.baseUrl);

client.requestFilter = (req: IRequestInit) => req.headers.append('x-tm3-date', new Date().toJSON());

client.onAuthenticationRequired = async () => {
  cache.authStore.isAuthenticated = false;
  clearToken();
};

function clearToken() {
  window.sessionStorage.removeItem('refreshToken');
}

function thirdPartyCookiesEnabled() {
  try {
    return (
      'cookie' in document &&
      (document.cookie.length > 0 ||
        (document.cookie = '3rdPartyTest').indexOf.call(document.cookie, '3rdPartyTest') > -1)
    );
  } catch (err) {
    return false;
  }
}

function setTokens(bearerToken: string, refreshToken: string) {
  if (!thirdPartyCookiesEnabled()) {
    client.bearerToken = bearerToken;
    client.refreshToken = refreshToken;
  }
}

function saveRefreshToken(refreshToken: string) {
  if (!thirdPartyCookiesEnabled()) {
    window.sessionStorage.refreshToken = refreshToken;
  }
}

if (!thirdPartyCookiesEnabled()) {
  const token = window.sessionStorage.refreshToken;
  if (token) {
    client.refreshToken = token;
  }
}

export { client, setTokens, clearToken, saveRefreshToken };
